"use client"
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from "react-router-dom"
import { ThemeProvider } from "./contexts/ThemeContext"
import Dashboard from "./components/pages/dashboard/Dashboard.jsx"
import Home from "./components/pages/dashboard/Home.jsx"
import { AuthProvider } from "./contexts/AuthContext"
import SignIn from "./components/pages/auth/SignIn.jsx"
import Wabadash from "./components/pages/dashboard/Wabadash.jsx"
import Useraccount from "./components/pages/dashboard/Useraccount.jsx"
import Reseller from "./components/pages/dashboard/Reseller.jsx"
import AdminDashboard from "./components/pages/dashboard/AdminDashboard.jsx"
import SuperAdminDashboard from "./components/pages/dashboard/SuperAdminDashboard.jsx"
import Userprofile from "./components/pages/dashboard/Userprofile.jsx"
import Metaprice from "./components/pages/dashboard/Metaprice.jsx"
import RefundHistory from "./components/pages/reports/RefundHistory.jsx"
import Recharge from "./components/pages/balance/Recharge.jsx"
import AdminRecharge from "./components/pages/balance/AdminRecharge.jsx"
import UserRecharge from "./components/pages/balance/UserRecharge.jsx"
import Campaign from "./components/pages/campaign/Campaign.jsx"
import SingleCampaign from "./components/pages/campaign/SingleCampaign.jsx"
import Campaignhistory from "./components/pages/campaign/campaignhistory.jsx"
import Queue from "./components/pages/campaign/queue.jsx"
import Chat from "./components/pages/chat/Chat.jsx"
import Bot from "./components/pages/chat/Bot.jsx"
import Botflow from "./components/pages/chat/BotFlow.jsx"
import BotCanvas from "./components/pages/chat/BotCanvas.jsx"
import Templates from "./components/pages/templates/Templates.jsx"
import Createtemp from "./components/pages/templates/Createtemp.jsx"
import Campignreport from "./components/pages/reports/Campignreport.jsx"
import APIreport from "./components/pages/reports/APIreport.jsx"
import ConversationReport from "./components/pages/reports/ConversationReport.jsx"
import CampaignConversationalReport from "./components/pages/reports/CampaignConversationalReport.jsx"
import Contact from "./components/pages/contact/Contact.jsx"
import Group from "./components/pages/contact/Group.jsx"
import Apikey from "./components/pages/documentation/Apikey.jsx"
import Support from "./components/pages/support/Support.jsx"
import UserProfileRedirect from "./components/pages/dashboard/UserProfileRedirect.jsx"
import WhatsappEmbeddedSignup from "./components/pages/whatsapp/WhatsappEmbeddedSignup.js"
import TermsPage from "./components/pages/auth/TermsPage.jsx"
import PrivacyPage from "./components/pages/auth/PrivacyPage.jsx"
import { useAuth } from "./contexts/AuthContext"
import RoleGuard from "./components/common/RoleGuard.jsx"
import UnauthorizedPage from "./components/pages/auth/UnauthorizedPage.jsx"
import "./App.css"

const Router = window.location.protocol === "file:" ? HashRouter : BrowserRouter

function DashboardIndexRedirect() {
  const { user } = useAuth()
  const role = (user?.role || "user").toLowerCase()
  if (role === "superadmin") return <Navigate to="/su-admin" replace />
  if (role === "admin") return <Navigate to="/dash-admin" replace />
  if (role === "reseller") return <Navigate to="/dashreseller" replace />
  return <Navigate to="/dashusers" replace />
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <Router>
            <Routes>
              <Route path="/signin" element={<SignIn />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              <Route path="/" element={<Dashboard />}>
                <Route index element={<DashboardIndexRedirect />} />
                <Route path="dashboard" element={<DashboardIndexRedirect />} />
                <Route path="su-admin" element={<RoleGuard allowedRoles={["superadmin"]}><SuperAdminDashboard /></RoleGuard>} />
                <Route path="dash-admin" element={<RoleGuard allowedRoles={["admin", "superadmin"]}><AdminDashboard /></RoleGuard>} />
                <Route path="dashreseller" element={<RoleGuard allowedRoles={["reseller", "admin", "superadmin"]}><Reseller /></RoleGuard>} />
                <Route path="dashusers" element={<RoleGuard allowedRoles={["user", "agent", "company", "admin", "superadmin"]}><Home /></RoleGuard>} />
                
                {/* Legacy route redirects */}
                <Route path="superadmin-dashboard" element={<Navigate to="/su-admin" replace />} />
                <Route path="admin-dashboard" element={<Navigate to="/dash-admin" replace />} />
                <Route path="reseller" element={<Navigate to="/dashreseller" replace />} />
                <Route path="main-dashboard" element={<Navigate to="/dashusers" replace />} />

                <Route path="waba-dashboard" element={<Wabadash />} />
                <Route path="user-accounts" element={<Useraccount />} />
                <Route path="userprofile" element={<UserProfileRedirect />} />
                <Route path="userprofile/:userId" element={<Userprofile />} />
                <Route path="meta" element={<RoleGuard allowedRoles={["superadmin", "admin", "reseller"]}><Metaprice /></RoleGuard>} />
                <Route path="refund-history" element={<RoleGuard allowedRoles={["superadmin", "admin"]}><RefundHistory /></RoleGuard>} />
                <Route path="recharge" element={<Recharge />} />
                <Route path="admin-recharge" element={<AdminRecharge />} />
                <Route path="user-recharge" element={<UserRecharge />} />
                <Route path="campaign" element={<Campaign />} />
                <Route path="single-campaign" element={<SingleCampaign />} />
                <Route path="campaign-history" element={<Campaignhistory />} />
                <Route path="queue" element={<Queue />} />
                <Route path="chat" element={<Chat />} />
                <Route path="bot" element={<Bot />} />
                <Route path="botflow" element={<Botflow />} />
                <Route path="botflow/:id" element={<BotCanvas />} />
                <Route path="templates" element={<Templates />} />
                <Route path="create-template" element={<Createtemp />} />
                <Route path="campaign-report" element={<Campignreport />} />
                <Route path="api-report" element={<APIreport />} />
                <Route path="conversation-report" element={<ConversationReport />} />
                <Route path="campaign-conversational-report" element={<CampaignConversationalReport />} />
                <Route path="contact" element={<Contact />} />
                <Route path="group" element={<Group />} />
                <Route path="api-key" element={<Apikey />} />
                <Route path="support" element={<Support />} />
                <Route path="whatsapp-signup" element={<RoleGuard allowedRoles={["superadmin", "admin", "reseller", "company", "user", "agent"]}><WhatsappEmbeddedSignup /></RoleGuard>} />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
        </div>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
